import {parseValueWithUnit} from './parse-value-with-unit.fn';
import {getConversionFactors} from './conversion-factors.fn';

/**
 * Convert value with unit to base value (bytes for storage, seconds for time)
 * @param valueStr String containing value and unit
 * @param featureType Type of feature
 * @returns Base value as string
 *
 * @author Claude Code
 */
export const convertToBaseValue = (
	valueStr: string,
	featureType: 'storage' | 'time' | 'count' | 'string'
): string => {
	if (featureType === 'string') {
		// For string types (codec, resolution), return as-is
		return valueStr;
	}

	const {value, unit} = parseValueWithUnit(valueStr);

	if (isNaN(value)) {
		return valueStr;
	}

	const conversionFactors = getConversionFactors();
	const conversionFactor = conversionFactors[unit] || 1;
	const baseValue = value * conversionFactor;

	return Math.round(baseValue).toString();
};
